var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.55797 21.75C16.6123 21.75 21.5661 14.2468 21.5661 7.74192C21.5661 7.53098 21.5614 7.31536 21.552 7.10442C22.5157 6.40752 23.3473 5.54432 24.0078 4.55536C23.1103 4.95466 22.1575 5.21544 21.1817 5.3288C22.2091 4.71297 22.9783 3.74553 23.3469 2.60583C22.3804 3.17862 21.3234 3.58267 20.2213 3.80067C19.4787 3.01162 18.4968 2.48918 17.4275 2.31411C16.3582 2.13905 15.261 2.32111 14.3056 2.83216C13.3501 3.3432 12.5896 4.15477 12.1417 5.14137C11.6937 6.12798 11.5832 7.23468 11.8273 8.29036C9.87031 8.19215 7.95575 7.68377 6.20779 6.79816C4.45984 5.91255 2.91751 4.6695 1.68078 3.14958C1.05221 4.2333 0.859869 5.51571 1.14284 6.73615C1.42582 7.9566 2.16288 9.02351 3.20422 9.72005C2.42244 9.69523 1.65779 9.48474 0.973438 9.10598V9.16692C0.972737 10.3042 1.36591 11.4066 2.08612 12.2868C2.80633 13.167 3.80914 13.7706 4.92406 13.995C4.19987 14.1932 3.43979 14.2221 2.70266 14.0794C3.01727 15.0575 3.62939 15.913 4.45358 16.5264C5.27778 17.1398 6.27293 17.4807 7.30016 17.5013C5.55624 18.8712 3.40199 19.6142 1.18438 19.6107C0.7911 19.6101 0.398212 19.586 0.0078125 19.5385C2.26067 20.9838 4.88134 21.7514 7.55797 21.75Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.0078125)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.1908340c.svg";
export { ForwardRef as ReactComponent };